"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const FlashcardAnswerSchema = zod_1.z.union([
    zod_1.z.literal("correct"),
    zod_1.z.literal("incorrect"),
]);
//# sourceMappingURL=flashcard_answer_types.js.map